<div class="row page-header">
    <div class="col-12">
        <h1>Fuel Record Defaults <small>Configure the default values for fuel recoreds by equipment</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="false"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="120"></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>-->
                        <wj-flex-grid-column [header]="'Cost Code'" [binding]="'costCode'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Cost Type'" [binding]="'costType'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Offset GL'"
                            [binding]="'offsetGl'"
                            [width]="120"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
